import React from 'react';
import PropTypes from 'prop-types';
import Cards from 'react-credit-cards';

export default function CardPreview({ paymentMethodOptions }) {
  const month = paymentMethodOptions.exp_month.toString().padStart(2, '0');
  const year = paymentMethodOptions.exp_year;

  const cardPrefixCount = ['amex', 'dinersclub'].includes(paymentMethodOptions.brand) ? 11 : 12;

  return (
    <Cards
      preview
      name={paymentMethodOptions.name}
      number={`${'*'.repeat(cardPrefixCount)}${paymentMethodOptions.last4}`}
      issuer={paymentMethodOptions.brand}
      expiry={`${month}/${year}`}
      cvc=""
    />
  );
}

CardPreview.propTypes = {
  paymentMethodOptions: PropTypes.object.isRequired,
};
